"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const summary = schema_1.Schema.string()
    .expiration(31536000)
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "lab_other_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ summary });
